import React from "react";
import { Alert } from "react-bootstrap";
import _isEmpty from "lodash/isEmpty";
import _includes from "lodash/includes";

export default function DeliveryAreaWarning({ deliveryArea }) {
  if (
    _isEmpty(deliveryArea) ||
    _includes(
      ["bundesweit", "deutschland", "deutschlandweit"],
      deliveryArea.toLowerCase(),
    )
  ) {
    return null;
  }

  // Show a warning when the producer only delivers to a local area:
  return <DeliveryAreaWarningLayout deliveryArea={deliveryArea} />;
}

const DeliveryAreaWarningLayout = props => (
  <Alert bsStyle="warning">
    <strong>Liefergebiet: {props.deliveryArea}</strong>
  </Alert>
);
